import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.sessions');
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-sessions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.sessions/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #0f172a;
}

.session-page {
  --session-blue: var(--wb-brand, #0f72b7);
  --session-blue-dark: #075985;
  --session-border: var(--wb-border, #dbe4ea);
  --session-muted: #f8fafc;
}

.session-secondary-button,
.session-primary-button,
.session-warning-button,
.session-safety-button,
.session-stop-button,
.session-player-button {
  display: inline-flex;
  min-height: 2.625rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 0.625rem;
  padding: 0.625rem 0.95rem;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.1;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
}

.session-secondary-button {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
}

.session-secondary-button:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.session-primary-button {
  border: 1px solid var(--session-blue);
  background: var(--session-blue);
  color: #ffffff;
}

.session-primary-button:hover {
  background: var(--session-blue-dark);
  border-color: var(--session-blue-dark);
}

.session-warning-button {
  border: 1px solid #f59e0b;
  background: #fffbeb;
  color: #92400e;
}

.session-safety-button {
  border: 1px solid #bfdbfe;
  background: #ffffff;
  color: #0369a1;
}

.session-safety-button:hover {
  background: #f0f9ff;
}

.session-stop-button {
  min-width: 9rem;
  border: 1px solid #dc2626;
  background: #dc2626;
  color: #ffffff;
}

.session-stop-button:hover {
  background: #b91c1c;
}

.session-secondary-button:disabled,
.session-primary-button:disabled,
.session-warning-button:disabled,
.session-safety-button:disabled,
.session-stop-button:disabled,
.session-player-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.session-label {
  display: block;
  margin-bottom: 0.4rem;
  color: #475569;
  font-size: 0.8125rem;
  font-weight: 700;
}

.session-select,
.session-compact-select {
  display: block;
  min-height: 2.65rem;
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 0.625rem;
  background: #ffffff;
  padding: 0.55rem 2.25rem 0.55rem 0.75rem;
  color: #1e293b;
  font-size: 0.8125rem;
}

.session-compact-select {
  min-width: 15rem;
  width: auto;
}

.session-select:focus,
.session-compact-select:focus {
  border-color: var(--session-blue);
  outline: none;
  box-shadow: 0 0 0 3px rgba(15, 114, 183, 0.14);
}

.session-workflow-step {
  position: relative;
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.25rem;
  color: #64748b;
}

.session-workflow-step:not(:last-child)::after {
  position: absolute;
  right: 0;
  width: 1px;
  height: 2rem;
  background: #e2e8f0;
  content: "";
}

.session-workflow-step strong,
.session-workflow-step span {
  display: block;
}

.session-workflow-step strong {
  font-size: 0.875rem;
  color: #334155;
}

.session-workflow-step div > span {
  margin-top: 0.15rem;
  font-size: 0.75rem;
}

.session-workflow-number {
  display: flex !important;
  width: 2.1rem;
  height: 2.1rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #ffffff;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 800;
}

.session-workflow-step-active {
  background: #f0f9ff;
}

.session-workflow-step-active .session-workflow-number {
  border-color: var(--session-blue);
  background: var(--session-blue);
  color: #ffffff;
}

.session-workflow-step-active strong {
  color: var(--session-blue-dark);
}

.session-workflow-step-done .session-workflow-number {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.session-section-title {
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 800;
}

.session-count-badge,
.session-media-badge {
  display: inline-flex;
  min-height: 1.5rem;
  align-items: center;
  border-radius: 999px;
  background: #eff6ff;
  padding: 0.2rem 0.55rem;
  color: #0369a1;
  font-size: 0.6875rem;
  font-weight: 800;
  white-space: nowrap;
}

.session-media-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.25rem;
  padding: 0.25rem;
  border: 1px solid #dbe4ea;
  border-radius: 0.75rem;
  background: #f1f5f9;
}

.session-media-tab {
  display: inline-flex;
  min-height: 2.5rem;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid transparent;
  border-radius: 0.55rem;
  color: #64748b;
  font-size: 0.8125rem;
  font-weight: 800;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease, box-shadow 140ms ease;
}

.session-media-tab:hover:not(:disabled) {
  color: #0f172a;
}

.session-media-tab-active {
  border-color: #dbe4ea;
  background: #ffffff;
  color: var(--session-blue-dark);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.session-media-tab:disabled {
  cursor: wait;
  opacity: 0.55;
}

.session-empty {
  display: flex;
  min-height: 10rem;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  border: 1px dashed #cbd5e1;
  border-radius: 0.75rem;
  background: #f8fafc;
  color: #64748b;
  font-size: 0.8125rem;
  line-height: 1.6;
  text-align: center;
}

.session-asset-thumbnail {
  position: relative;
  display: flex;
  width: 6rem;
  height: 4rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.625rem;
  background: #f1f5f9;
}

.session-video-play-badge {
  position: absolute;
  right: 0.4rem;
  bottom: 0.4rem;
  display: inline-flex;
  width: 1.55rem;
  height: 1.55rem;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.78);
  color: #ffffff;
  font-size: 0.9rem;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.22);
}

.session-model-badge {
  display: inline-flex;
  min-width: 0;
  max-width: 13.5rem;
  align-items: center;
  gap: 0.3rem;
  border-radius: 999px;
  background: #f8fafc;
  padding: 0.14rem 0.48rem;
  color: #475569;
  font-weight: 700;
}

.session-add-button {
  min-height: 2.25rem;
  flex: 0 0 auto;
  border: 1px solid #bae6fd;
  border-radius: 0.55rem;
  background: #ffffff;
  padding: 0 0.8rem;
  color: #0369a1;
  font-size: 0.75rem;
  font-weight: 800;
}

.session-add-button:hover {
  background: #f0f9ff;
}

.session-add-button:disabled {
  border-color: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
}

.session-order-number {
  display: flex;
  width: 1.9rem;
  height: 1.9rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #334155;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 800;
}

.session-order-number-done {
  background: #059669;
}

.session-icon-button {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 0.45rem;
  color: #64748b;
  font-size: 0.75rem;
}

.session-icon-button:hover {
  background: #f8fafc;
}

.session-icon-button-danger {
  border-color: #fecaca;
  color: #dc2626;
}

.session-console-grid,
.session-history-grid {
  display: grid;
  grid-template-columns: minmax(13rem, 0.85fr) minmax(28rem, 2.2fr) minmax(15rem, 1fr);
  gap: 1rem;
  align-items: start;
}

.session-history-grid {
  grid-template-columns: minmax(15rem, 0.9fr) minmax(30rem, 2.1fr) minmax(17rem, 1fr);
}

.session-console-panel {
  overflow: hidden;
  border: 1px solid #dbe4ea;
  border-radius: 0.8rem;
  background: #ffffff;
  box-shadow: 0 7px 24px rgba(15, 23, 42, 0.045);
}

.session-panel-header {
  display: flex;
  min-height: 3.75rem;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.85rem 1rem;
}

.session-panel-header h2 {
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 800;
}

.session-panel-header > span {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
}

.session-plan-item {
  display: flex;
  width: 100%;
  min-height: 5rem;
  align-items: center;
  gap: 0.75rem;
  border-left: 3px solid transparent;
  padding: 0.85rem;
  text-align: left;
}

.session-plan-item:hover {
  background: #f8fafc;
}

.session-plan-item-active {
  border-left-color: var(--session-blue);
  background: #f0f9ff;
}

.session-media-stage {
  position: relative;
  display: flex;
  min-height: 28rem;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0.75rem;
  background: #0b1220;
}

.session-stage-message {
  max-width: 30rem;
  padding: 2rem;
  color: #cbd5e1;
  font-size: 0.875rem;
  line-height: 1.65;
  text-align: center;
}

.session-player-button {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
  padding-block: 0.9rem;
}

.session-player-button:hover {
  background: #f8fafc;
}

.session-player-button-pause {
  border-color: #f59e0b;
  background: #f59e0b;
  color: #ffffff;
}

.session-player-button-pause:hover {
  background: #d97706;
}

.session-suds-preset {
  min-height: 2.25rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  background: #ffffff;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 800;
}

.session-suds-preset:hover,
.session-suds-preset-active {
  border-color: var(--session-blue);
  background: var(--session-blue);
  color: #ffffff;
}

.session-history-item {
  display: block;
  width: 100%;
  border-left: 3px solid transparent;
  padding: 1rem;
  text-align: left;
}

.session-history-item:hover {
  background: #f8fafc;
}

.session-history-item-active {
  border-left-color: var(--session-blue);
  background: #f0f9ff;
}

.session-result-row {
  display: flex;
  min-height: 3.4rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  color: #475569;
  font-size: 0.8125rem;
}

.session-result-row strong {
  color: #0f172a;
  font-size: 1rem;
}

.session-page button:focus-visible,
.session-page a:focus-visible,
.session-page select:focus-visible,
.session-page input:focus-visible,
.session-page textarea:focus-visible {
  outline: 3px solid rgba(14, 165, 233, 0.35);
  outline-offset: 2px;
}

input[type=range] {
  accent-color: var(--session-blue);
}

@media (max-width: 1279px) {
  .session-console-grid,
  .session-history-grid {
    grid-template-columns: minmax(12rem, 0.8fr) minmax(25rem, 2fr);
  }
  .session-console-grid > aside:last-child,
  .session-history-grid > aside:last-child {
    grid-column: 1/-1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
  }
  .session-history-grid > aside:last-child {
    display: block;
  }
}
@media (max-width: 899px) {
  .session-console-grid,
  .session-history-grid {
    grid-template-columns: 1fr;
  }
  .session-console-grid > aside:last-child,
  .session-history-grid > aside:last-child {
    grid-column: auto;
    display: block;
  }
  .session-workflow-step {
    padding: 0.8rem;
  }
  .session-workflow-step div > span {
    display: none;
  }
  .session-compact-select {
    width: 100%;
    min-width: 0;
  }
  .session-media-stage {
    min-height: 20rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  :host * {
    scroll-behavior: auto;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`],
})
export class PageSessionsComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public listLoading: boolean = false;
    public assetsLoading: boolean = false;
    public detailLoading: boolean = false;
    public creating: boolean = false;
    public commandBusy: string = '';
    public checkpointBusy: boolean = false;
    public polling: boolean = false;
    public accessDenied: boolean = false;
    public errorMessage: string = '';
    public assetError: string = '';
    public detailError: string = '';
    public csrfTokenValue: string = '';

    public patients: any[] = [];
    public approvedAssets: any[] = [];
    public plan: any[] = [];
    public sessions: any[] = [];
    public selectedSession: any = null;
    public selectedPlanIndex: number = 0;
    public selectedSessionKey: string = '';
    public viewMode: 'operate' | 'history' = 'operate';
    public planningMode: boolean = false;

    public sessionFilter: any = { status: '', patient_id: '' };
    public sessionPage: number = 1;
    public sessionDump: number = 20;
    public sessionTotal: number = 0;
    public assetMediaType: string = 'image';
    public assetPage: number = 1;
    public assetDump: number = 50;
    public assetTotal: number = 0;
    public createPatientId: string = '';
    public sudsForm: any = { value: 50, phase: 'baseline' };
    public safetyForm: any = { reason_code: '', severity: 1 };
    public abortReason: string = '';

    public statusOptions: any[] = [
        { value: '', label: '전체 상태' },
        { value: 'scheduled', label: '예정' },
        { value: 'running', label: '진행 중' },
        { value: 'paused', label: '일시정지' },
        { value: 'completed', label: '완료' },
        { value: 'aborted', label: '중단' }
    ];
    public mediaTypes: any[] = [
        { value: 'image', label: '이미지', icon: 'fa-solid fa-image' },
        { value: 'audio', label: '오디오', icon: 'fa-solid fa-wave-square' },
        { value: 'video', label: '영상', icon: 'fa-solid fa-play' }
    ];
    public sudsPhases: any[] = [
        { value: 'baseline', label: '시작 전' },
        { value: 'during', label: '진행 중' },
        { value: 'post', label: '마무리(완료 전)' }
    ];
    public safetyReasons: any[] = [
        { value: 'dissociation', label: '해리 반응' },
        { value: 'panic_escalation', label: '공황 악화' },
        { value: 'distress_threshold', label: '고통 임계치 초과' },
        { value: 'physical_symptom', label: '신체 증상' },
        { value: 'patient_request', label: '환자 요청' },
        { value: 'technical_issue', label: '기술 문제' },
        { value: 'other', label: '기타 안전 사유' }
    ];

    private pollTimer: any = null;
    private createKey: string = '';
    private commandKeys: { [fingerprint: string]: string } = {};
    private playbackSentAt: { [fingerprint: string]: number } = {};
    private mediaRefreshAttempts: { [assetId: string]: { failedUrl: string, retried: boolean } } = {};
    private assetPreviewRefreshAttempts: { [assetId: string]: number } = {};
    private suppressMediaEventsUntil: number = 0;
    private selectionGeneration: number = 0;
    private detailRequestSerial: number = 0;
    private pollingOwner: number = 0;
    private pollingGeneration: number = -1;
    private detailLoadingOwner: number = 0;
    private detailLoadingGeneration: number = -1;
    private requestedPatientId: string = '';
    private requestedRevisionId: string = '';
    private requestedMediaType: string = '';
    private requestedSessionId: string = '';
    private sudsChart: any = null;

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        if (!this.can('sessions.operate')) {
            this.accessDenied = true;
            this.loading = false;
            await this.service.render();
            return;
        }
        const parameters = this.route.snapshot.queryParamMap;
        this.viewMode = parameters.get('view') === 'history' ? 'history' : 'operate';
        this.requestedSessionId = this.normalizeIdentifier(parameters.get('session_id'));
        this.requestedPatientId = this.normalizeIdentifier(
            parameters.get('patient_id')
        );
        this.requestedRevisionId = this.normalizeIdentifier(
            parameters.get('asset_revision_id')
        );
        this.requestedMediaType = this.normalizeMediaType(
            parameters.get('media_type')
        );
        await this.bootstrap();
        if (this.requestedPatientId) {
            this.planningMode = true;
            await this.applyLinkedAsset();
        } else {
            await this.selectInitialSession();
        }
    }

    public ngOnDestroy() {
        this.selectionGeneration += 1;
        this.stopPolling();
        if (this.sudsChart) this.sudsChart.destroy();
        this.sudsChart = null;
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    public csrfToken() {
        return this.csrfTokenValue || this.service.auth?.session?.csrf_token || '';
    }

    private newKey(prefix: string) {
        return prefix + ':' + this.service.random(32);
    }

    private commandFingerprint(command: string, payload: any) {
        const fields = [
            this.sessionId(this.selectedSession),
            command,
            payload?.asset_revision_id || '',
            payload?.position_ms ?? '',
            payload?.playback_action || '',
            payload?.suds_value ?? '',
            payload?.suds_phase || '',
            payload?.reason_code || '',
            payload?.severity ?? ''
        ];
        return fields.join('|');
    }

    public async bootstrap() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('bootstrap');
            if (code !== 200) {
                this.errorMessage = data?.message || '치료 세션 화면을 불러오지 못했습니다.';
                return;
            }
            this.patients = Array.isArray(data?.patients) ? data.patients : [];
            this.sessions = Array.isArray(data?.sessions) ? data.sessions : [];
            this.sessionTotal = Number(data?.total || this.sessions.length);
            this.sessionPage = Number(data?.page || 1);
            this.sessionDump = Number(data?.dump || 20);
            this.csrfTokenValue = data?.csrf_token || this.csrfTokenValue;
        } catch (error) {
            this.errorMessage = '치료 세션 화면을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async onPatientChanged() {
        this.plan = [];
        this.approvedAssets = [];
        this.assetTotal = 0;
        this.assetMediaType = 'image';
        this.assetPage = 1;
        this.createKey = '';
        this.assetError = '';
        this.assetPreviewRefreshAttempts = {};
        await this.service.render();
        if (this.createPatientId) await this.loadAssets();
    }

    public async selectAssetMediaType(mediaType: string) {
        const normalized = this.normalizeMediaType(mediaType);
        if (!normalized || this.assetsLoading || this.creating) return;
        this.assetMediaType = normalized;
        this.assetPage = 1;
        this.approvedAssets = [];
        this.assetTotal = 0;
        this.assetError = '';
        this.assetPreviewRefreshAttempts = {};
        await this.service.render();
        if (this.createPatientId) await this.loadAssets();
    }

    public activeAssetMediaLabel() {
        return this.mediaTypes.find((item: any) => item.value === this.assetMediaType)?.label || '콘텐츠';
    }

    public activeAssetMediaIcon() {
        return this.mediaTypes.find((item: any) => item.value === this.assetMediaType)?.icon
            || 'fa-solid fa-photo-film';
    }

    public async loadAssets(revisionId: string = ''): Promise<boolean> {
        if (!this.createPatientId || this.assetsLoading) return false;
        this.assetsLoading = true;
        this.assetError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.app('component.session_assets_v2').call('search', {
                patient_id: this.createPatientId,
                media_type: this.assetMediaType,
                revision_id: this.normalizeIdentifier(revisionId),
                page: this.assetPage,
                dump: this.assetDump
            });
            if (code !== 200) {
                this.assetError = data?.message || '치료 자산을 불러오지 못했습니다.';
                return false;
            }
            this.approvedAssets = Array.isArray(data?.assets) ? data.assets : [];
            this.assetTotal = Number(data?.total || this.approvedAssets.length);
            this.assetPage = Number(data?.page || this.assetPage);
            this.assetDump = Number(data?.dump || this.assetDump);
            return true;
        } catch (error) {
            this.assetError = '치료 자산을 불러오지 못했습니다.';
            return false;
        } finally {
            this.assetsLoading = false;
            await this.service.render();
        }
    }

    private async applyLinkedAsset() {
        if (!this.requestedPatientId) return;
        const patientVisible = this.patients.some((patient: any) =>
            this.normalizeIdentifier(patient?.id || patient?.patient_id)
                === this.requestedPatientId
        );
        if (!patientVisible) {
            this.errorMessage = '연결할 환자를 현재 담당 범위에서 찾을 수 없습니다.';
            await this.service.render();
            return;
        }

        this.createPatientId = this.requestedPatientId;
        this.sessionFilter.patient_id = this.requestedPatientId;
        this.assetMediaType = 'image';
        this.assetPage = 1;

        if (!this.requestedRevisionId) {
            this.assetMediaType = this.requestedMediaType || 'image';
            await this.loadAssets();
            return;
        }

        this.assetMediaType = '';

        const exactLoaded = await this.loadAssets(this.requestedRevisionId);
        if (!exactLoaded) return;
        let linkedAsset = this.approvedAssets.find((asset: any) =>
            this.assetId(asset) === this.requestedRevisionId
        );
        this.assetMediaType = this.requestedMediaType;
        if (!this.assetMediaType) {
            this.assetMediaType = linkedAsset ? this.mediaType(linkedAsset) : 'image';
        }
        const listLoaded = await this.loadAssets();
        if (!listLoaded) return;
        if (!linkedAsset) {
            linkedAsset = this.approvedAssets.find((asset: any) =>
                this.assetId(asset) === this.requestedRevisionId
            );
        }
        if (!linkedAsset) {
            this.assetError = '연결한 자산이 안전성 조건을 충족하지 않거나 현재 환자의 자산이 아닙니다.';
            await this.service.render();
            return;
        }
        await this.addToPlan(linkedAsset);
    }

    private normalizeIdentifier(value: any) {
        const identifier = String(value || '').trim();
        return /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/.test(identifier)
            ? identifier
            : '';
    }

    private normalizeMediaType(value: any) {
        const mediaType = String(value || '').trim().toLowerCase();
        return ['image', 'audio', 'video'].includes(mediaType) ? mediaType : '';
    }

    public assetPageCount() {
        return Math.max(1, Math.ceil(this.assetTotal / this.assetDump));
    }

    public async changeAssetPage(page: number) {
        const target = Math.max(1, Math.min(this.assetPageCount(), page));
        if (target === this.assetPage || this.assetsLoading) return;
        this.assetPage = target;
        await this.loadAssets();
    }

    public isPlanned(asset: any) {
        const id = this.assetId(asset);
        return this.plan.some((item: any) => this.assetId(item) === id);
    }

    public async addToPlan(asset: any) {
        if (!asset || this.isPlanned(asset) || this.creating) return;
        this.plan = [...this.plan, asset];
        this.createKey = '';
        await this.service.render();
    }

    public async removeFromPlan(index: number) {
        if (this.creating || index < 0 || index >= this.plan.length) return;
        this.plan = this.plan.filter((_: any, itemIndex: number) => itemIndex !== index);
        this.createKey = '';
        await this.service.render();
    }

    public async movePlan(index: number, direction: number) {
        const target = index + direction;
        if (this.creating || target < 0 || target >= this.plan.length) return;
        const next = [...this.plan];
        [next[index], next[target]] = [next[target], next[index]];
        this.plan = next;
        this.createKey = '';
        await this.service.render();
    }

    public async createSession() {
        if (this.creating || !this.can('sessions.operate')) return;
        if (!this.createPatientId || this.plan.length === 0) {
            await this.service.modal.error('비식별 환자와 치료 자산을 1개 이상 선택해주세요.');
            return;
        }
        if (this.plan.length > 20) {
            await this.service.modal.error('한 세션에는 치료 자산을 최대 20개까지 배치할 수 있습니다.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '치료 세션 계획 생성',
            message: '현재 순서로 생성 완료·안전 통과 revision을 고정한 세션 계획을 만듭니다.',
            action: '계획 생성',
            cancel: '취소',
            status: 'success',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        if (!this.createKey) this.createKey = this.newKey('session-create');
        this.creating = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('create', {
                patient_id: this.createPatientId,
                revision_ids: JSON.stringify(this.plan.map((item: any) => this.assetId(item))),
                idempotency_key: this.createKey,
                csrf_token: this.csrfToken()
            });
            if (![200, 201].includes(code)) {
                this.errorMessage = data?.message || '치료 세션 계획을 만들지 못했습니다.';
                return;
            }
            const created = data?.session || null;
            this.createKey = '';
            this.plan = [];
            await this.loadSessions(false, true);
            if (created?.session_id || created?.id) {
                await this.selectSession(created);
            }
            await this.service.modal.success('치료 세션 계획을 만들었습니다.');
        } catch (error) {
            this.errorMessage = '치료 세션 계획을 만들지 못했습니다.';
        } finally {
            this.creating = false;
            await this.service.render();
        }
    }

    public async loadSessions(showLoading: boolean = true, resetPage: boolean = false) {
        if (this.listLoading) return;
        if (resetPage) this.sessionPage = 1;
        this.listLoading = showLoading;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('search', {
                scope: 'sessions',
                status: this.sessionFilter.status || '',
                patient_id: this.sessionFilter.patient_id || '',
                page: this.sessionPage,
                dump: this.sessionDump
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '치료 세션 목록을 불러오지 못했습니다.';
                return;
            }
            this.sessions = Array.isArray(data?.sessions) ? data.sessions : [];
            this.sessionTotal = Number(data?.total || this.sessions.length);
            this.sessionPage = Number(data?.page || this.sessionPage);
            this.sessionDump = Number(data?.dump || this.sessionDump);
        } catch (error) {
            this.errorMessage = '치료 세션 목록을 불러오지 못했습니다.';
        } finally {
            this.listLoading = false;
            await this.service.render();
        }
    }

    public sessionPageCount() {
        return Math.max(1, Math.ceil(this.sessionTotal / this.sessionDump));
    }

    public async changeSessionPage(page: number) {
        const target = Math.max(1, Math.min(this.sessionPageCount(), page));
        if (target === this.sessionPage || this.listLoading) return;
        this.sessionPage = target;
        await this.loadSessions();
    }

    public sessionId(item: any) {
        return String(item?.session_id || item?.id || '');
    }

    public async selectSession(item: any) {
        const id = this.sessionId(item);
        if (!id || this.detailLoading || this.commandBusy || this.checkpointBusy) return;
        const generation = ++this.selectionGeneration;
        this.stopPolling();
        this.planningMode = false;
        this.selectedSessionKey = id;
        this.selectedSession = { ...item, session_id: id };
        this.selectedPlanIndex = 0;
        this.mediaRefreshAttempts = {};
        this.detailError = '';
        await this.service.render();
        await this.loadDetail(false, 0);
        if (generation !== this.selectionGeneration) return;
        await this.drainTimeline();
        if (generation !== this.selectionGeneration) return;
        this.syncPolling();
    }

    public async loadDetail(silent: boolean = false, afterSequence: number = 0) {
        const id = this.sessionId(this.selectedSession);
        const generation = this.selectionGeneration;
        if (!id) return;
        if (silent && this.polling && this.pollingGeneration === generation) return;
        if (!silent && this.detailLoading && this.detailLoadingGeneration === generation) return;
        const requestId = ++this.detailRequestSerial;
        if (silent) {
            this.polling = true;
            this.pollingOwner = requestId;
            this.pollingGeneration = generation;
        } else {
            this.detailLoading = true;
            this.detailLoadingOwner = requestId;
            this.detailLoadingGeneration = generation;
        }
        if (!silent) this.detailError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('detail', {
                session_id: id,
                after_sequence: afterSequence
            });
            if (code !== 200) {
                if (!silent && generation === this.selectionGeneration && id === this.sessionId(this.selectedSession)) {
                    this.detailError = data?.message || '세션 상세를 불러오지 못했습니다.';
                }
                return;
            }
            if (
                data?.session &&
                generation === this.selectionGeneration &&
                id === this.sessionId(this.selectedSession)
            ) {
                this.applySession(data.session, afterSequence > 0);
            }
        } catch (error) {
            if (!silent && generation === this.selectionGeneration && id === this.sessionId(this.selectedSession)) {
                this.detailError = '세션 상세를 불러오지 못했습니다.';
            }
        } finally {
            let changed = false;
            if (silent && this.pollingOwner === requestId) {
                this.polling = false;
                this.pollingOwner = 0;
                this.pollingGeneration = -1;
                changed = true;
            }
            if (!silent && this.detailLoadingOwner === requestId) {
                this.detailLoading = false;
                this.detailLoadingOwner = 0;
                this.detailLoadingGeneration = -1;
                changed = true;
            }
            if (changed || generation === this.selectionGeneration) await this.service.render();
        }
    }

    private applySession(incoming: any, appendTimeline: boolean = false) {
        const previous = this.selectedSession || {};
        const previousVersion = Number(previous?.version || 0);
        const incomingVersion = Number(incoming?.version || 0);
        const staleState = appendTimeline && previousVersion > 0 && incomingVersion > 0 && incomingVersion < previousVersion;
        const state = staleState ? { ...incoming, ...previous } : { ...previous, ...incoming };
        state.event_cursor = appendTimeline
            ? Math.max(
                Number(previous?.event_cursor || previous?.last_sequence || 0),
                Number(incoming?.event_cursor || incoming?.last_sequence || 0)
            )
            : Number(incoming?.event_cursor || incoming?.last_sequence || 0);
        state.last_sequence = state.event_cursor;
        state.last_event_sequence = appendTimeline
            ? Math.max(
                Number(previous?.last_event_sequence || 0),
                Number(incoming?.last_event_sequence || 0)
            )
            : Number(incoming?.last_event_sequence || 0);
        const previousTimeline = Array.isArray(previous.timeline) ? previous.timeline : [];
        const incomingTimeline = Array.isArray(incoming?.timeline) ? incoming.timeline : [];
        const timeline = appendTimeline
            ? this.mergeTimeline(previousTimeline, incomingTimeline)
            : incomingTimeline;
        // Incremental polling is timeline-only. Keeping the existing plan also
        // keeps the currently playing signed URL stable until it actually fails.
        const plan = appendTimeline
            ? this.stablePlan(
                Array.isArray(previous.plan) ? previous.plan : [],
                Array.isArray(incoming?.plan) ? incoming.plan : [],
                state?.status
            )
            : (Array.isArray(incoming?.plan) ? incoming.plan : []);
        const nextSelected = plan[this.selectedPlanIndex] || null;
        if (
            (previous?.status === 'running' && state?.status !== 'running') ||
            (state?.status === 'running' && nextSelected && nextSelected.asset_available !== true)
        ) {
            this.pauseMedia();
        }
        this.selectedSession = { ...state, plan, timeline };
        if (this.viewMode === 'history') {
            setTimeout(() => this.renderSudsChart(), 0);
        }
        const activeRevisionId = String(this.selectedSession?.current_asset_revision_id || '');
        const activeIndex = activeRevisionId
            ? plan.findIndex((item: any) => this.assetId(item) === activeRevisionId)
            : -1;
        if (activeIndex >= 0) this.selectedPlanIndex = activeIndex;
        else if (this.selectedPlanIndex >= plan.length) this.selectedPlanIndex = Math.max(0, plan.length - 1);

        const id = this.sessionId(this.selectedSession);
        this.sessions = this.sessions.map((row: any) =>
            this.sessionId(row) === id ? { ...row, ...this.selectedSession, timeline: undefined } : row
        );
    }

    private stablePlan(previous: any[], incoming: any[], status: string) {
        const operational = status === 'running';
        const updates: { [id: string]: any } = {};
        incoming.forEach((item: any) => {
            updates[String(item?.plan_item_id || this.assetId(item))] = item;
        });
        return previous.map((oldItem: any) => {
            const key = String(oldItem?.plan_item_id || this.assetId(oldItem));
            const update = updates[key] || {};
            const merged = { ...oldItem, ...update };
            const available = merged?.asset_available === true;
            merged.signed_url = operational && available ? oldItem?.signed_url || '' : '';
            const oldArtifacts = Array.isArray(oldItem?.artifacts) ? oldItem.artifacts : [];
            const nextArtifacts = Array.isArray(merged?.artifacts) ? merged.artifacts : [];
            merged.artifacts = nextArtifacts.map((artifact: any) => {
                const oldArtifact = oldArtifacts.find((candidate: any) =>
                    String(candidate?.artifact_id || candidate?.id) === String(artifact?.artifact_id || artifact?.id)
                );
                return {
                    ...artifact,
                    signed_url: operational && available ? oldArtifact?.signed_url || '' : ''
                };
            });
            return merged;
        });
    }

    private mergeTimeline(previous: any[], incoming: any[]) {
        const byKey: { [key: string]: any } = {};
        [...previous, ...incoming].forEach((event: any, index: number) => {
            const sequence = Number(event?.sequence || 0);
            const key = sequence > 0 ? 's:' + sequence : 'i:' + String(event?.id || index);
            byKey[key] = event;
        });
        return Object.values(byKey).sort((left: any, right: any) =>
            Number(left?.sequence || 0) - Number(right?.sequence || 0)
        );
    }

    private eventCursor() {
        if (this.selectedSession?.event_cursor !== undefined && this.selectedSession?.event_cursor !== null) {
            return Math.max(0, Number(this.selectedSession.event_cursor || 0));
        }
        const explicit = Number(this.selectedSession?.last_sequence || 0);
        const timeline = Array.isArray(this.selectedSession?.timeline) ? this.selectedSession.timeline : [];
        return timeline.reduce((last: number, event: any) => Math.max(last, Number(event?.sequence || 0)), explicit);
    }

    private async drainTimeline() {
        let batches = 0;
        while (this.selectedSession?.has_more_events === true && batches < 50) {
            const before = this.eventCursor();
            await this.loadDetail(true, before);
            batches += 1;
            if (this.eventCursor() <= before) break;
        }
    }

    private syncPolling() {
        this.stopPolling();
        if (!['running', 'paused'].includes(this.selectedSession?.status)) return;
        this.pollTimer = setInterval(() => {
            void this.pollDetail();
        }, 2000);
    }

    private stopPolling() {
        if (this.pollTimer) clearInterval(this.pollTimer);
        this.pollTimer = null;
    }

    private async pollDetail() {
        if (this.polling || this.detailLoading || this.commandBusy || !this.selectedSession) return;
        await this.loadDetail(true, this.eventCursor());
        await this.drainTimeline();
        if (!['running', 'paused'].includes(this.selectedSession?.status)) this.stopPolling();
    }

    public selectedPlanAsset() {
        const plan = Array.isArray(this.selectedSession?.plan) ? this.selectedSession.plan : [];
        return plan[this.selectedPlanIndex] || null;
    }

    public async selectPlanAsset(index: number) {
        const plan = Array.isArray(this.selectedSession?.plan) ? this.selectedSession.plan : [];
        if (index < 0 || index >= plan.length || index === this.selectedPlanIndex || this.checkpointBusy || this.commandBusy) return;
        this.pauseMedia();
        this.selectedPlanIndex = index;
        await this.service.render();
        if (['running', 'paused'].includes(this.selectedSession?.status)) {
            await this.recordCheckpoint(plan[index], 'seek', 0);
        }
    }

    public assetId(asset: any) {
        return String(asset?.asset_revision_id || asset?.revision_id || asset?.id || '');
    }

    public mediaType(asset: any) {
        const value = String(asset?.media_type || 'image').toLowerCase();
        return ['image', 'audio', 'video'].includes(value) ? value : 'image';
    }

    public mediaLabel(asset: any) {
        const type = this.mediaType(asset);
        if (type === 'audio') return '오디오';
        if (type === 'video') return '비디오';
        return '이미지';
    }

    public assetTitle(asset: any) {
        const scenario = String(asset?.scenario_type || '승인 콘텐츠').replace(/_/g, ' ');
        const intensity = asset?.intensity ? ' · 강도 ' + asset.intensity : '';
        return scenario + intensity;
    }

    public assetMeta(asset: any) {
        const values: string[] = [this.mediaLabel(asset)];
        if (asset?.duration_ms) values.push(this.duration(asset.duration_ms));
        if (asset?.width && asset?.height) values.push(asset.width + '×' + asset.height);
        return values.join(' · ');
    }

    public assetModelLabel(asset: any) {
        const engine = String(asset?.engine_name || '').trim().toLowerCase();
        const version = String(asset?.engine_version || '').trim().toLowerCase();
        const provider = String(asset?.provider_name || '').trim().toLowerCase();
        const requestedModel = String(asset?.model_name || '').trim().toLowerCase();
        const model = [engine, version, requestedModel].filter(Boolean).join(' ');

        if (model.includes('kling') || provider.includes('kling')) {
            return this.mediaType(asset) === 'image'
                ? 'Kling AI · Image 2.1'
                : 'Kling AI · Video 3.0';
        }
        if (model.includes('seedance')) return 'EvoLink · Seedance 2.5';
        if (model.includes('seedream')) return 'EvoLink · Seedream 5.0 Lite';
        if (model.includes('wan') || provider.includes('comfy')) return 'ComfyUI · Wan 2.2';
        if (model.includes('gpt-image') || provider.includes('openai')) return 'OpenAI · GPT Image 2';
        if (provider === 'mock' || model.includes('fixture') || model.includes('deterministic')) {
            return '내부 테스트 모델';
        }
        return String(
            asset?.model_name
            || asset?.engine_version
            || asset?.engine_name
            || asset?.provider_name
            || '모델 정보 없음'
        );
    }

    public assetListLabel(asset: any, index: number) {
        const title = String(asset?.title || '').trim();
        const scenario = String(asset?.scenario_type || '').trim();
        if (
            title
            && title.toLowerCase() !== scenario.toLowerCase()
            && title.toLowerCase() !== this.mediaType(asset)
        ) return title;
        const sequence = (this.assetPage - 1) * this.assetDump + index + 1;
        return this.mediaLabel(asset) + ' ' + sequence;
    }

    public assetPreviewKind(asset: any) {
        const kind = String(asset?.preview_kind || '').trim().toLowerCase();
        return ['image', 'audio', 'video'].includes(kind) ? kind : '';
    }

    public async onAssetPreviewError(asset: any) {
        const key = this.assetId(asset);
        const attempts = Number(this.assetPreviewRefreshAttempts[key] || 0);
        if (!key || !this.createPatientId || attempts >= 1) {
            if (asset) asset.preview_failed = true;
            await this.service.render();
            return;
        }

        this.assetPreviewRefreshAttempts[key] = attempts + 1;
        try {
            const { code, data } = await wiz.app('component.session_assets_v2').call('search', {
                patient_id: this.createPatientId,
                media_type: this.mediaType(asset),
                revision_id: key,
                page: 1,
                dump: 50
            });
            const fresh = Array.isArray(data?.assets)
                ? data.assets.find((item: any) => this.assetId(item) === key)
                : null;
            if (code === 200 && fresh?.preview_url) {
                fresh.preview_url = fresh.preview_url
                    + (fresh.preview_url.includes('?') ? '&' : '?')
                    + 'refresh=' + Date.now();
                Object.assign(asset, fresh, { preview_failed: false });
            } else {
                asset.preview_failed = true;
            }
        } catch (error) {
            asset.preview_failed = true;
        }
        await this.service.render();
    }

    public onAssetPreviewLoaded(asset: any) {
        const key = this.assetId(asset);
        if (key) delete this.assetPreviewRefreshAttempts[key];
        if (asset) asset.preview_failed = false;
    }

    public duration(value: any) {
        const totalSeconds = Math.max(0, Math.floor(Number(value || 0) / 1000));
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return minutes + ':' + seconds;
    }

    public patientLabel(patientId: string) {
        const patient = this.patients.find((item: any) => item.id === patientId || item.patient_id === patientId);
        return patient?.patient_code || patient?.label || this.selectedSession?.patient_code || '비식별 환자';
    }

    public statusLabel(status: string) {
        return this.statusOptions.find((item: any) => item.value === status)?.label || status || '상태 없음';
    }

    public statusClass(status: string) {
        const styles: any = {
            scheduled: 'border-blue-200 bg-blue-50 text-blue-700',
            running: 'border-emerald-200 bg-emerald-50 text-emerald-700',
            paused: 'border-amber-200 bg-amber-50 text-amber-700',
            completed: 'border-gray-200 bg-gray-100 text-gray-700',
            aborted: 'border-red-200 bg-red-50 text-red-700'
        };
        return styles[status] || 'border-gray-200 bg-white text-gray-600';
    }

    public canOperate() {
        return ['scheduled', 'running', 'paused'].includes(this.selectedSession?.status);
    }

    public canPlay() {
        return this.selectedSession?.status === 'running';
    }

    public canDisplayMedia() {
        return this.selectedSession?.status === 'running';
    }

    private pauseMedia() {
        this.suppressMediaEventsUntil = Date.now() + 1000;
        document.querySelectorAll('wiz-page-sessions audio, wiz-page-sessions video').forEach((element: any) => {
            if (typeof element.pause === 'function') element.pause();
        });
    }

    public async runStateCommand(command: string) {
        if (!this.selectedSession || this.commandBusy || this.checkpointBusy) return;
        const status = this.selectedSession.status;
        const allowed: any = {
            start: status === 'scheduled',
            pause: status === 'running',
            resume: status === 'paused',
            complete: ['running', 'paused'].includes(status)
        };
        if (!allowed[command]) return;

        if (command === 'complete') {
            const confirmed = await this.service.modal.show({
                title: '치료 세션 완료',
                message: '세션을 완료하면 추가 재생 이벤트를 기록할 수 없습니다.',
                action: '완료',
                cancel: '취소',
                status: 'success',
                actionBtn: 'success'
            });
            if (!confirmed) return;
        }
        if (command === 'pause' || command === 'complete') this.pauseMedia();
        await this.sendCommand(command, this.playbackPositionPayload());
    }

    private playbackPositionPayload() {
        const asset = this.selectedPlanAsset();
        const element: any = document.querySelector('wiz-page-sessions audio, wiz-page-sessions video');
        const currentAssetId = asset ? this.assetId(asset) : '';
        const fallbackPosition = currentAssetId && currentAssetId === String(this.selectedSession?.current_asset_revision_id || '')
            ? Number(this.selectedSession?.playback_position_ms || 0)
            : 0;
        return {
            asset_revision_id: currentAssetId,
            position_ms: element && Number.isFinite(element.currentTime)
                ? Math.max(0, Math.round(element.currentTime * 1000))
                : Math.max(0, Math.round(fallbackPosition))
        };
    }

    public async abortSession() {
        if (!this.canOperate() || this.commandBusy || this.checkpointBusy) return;
        if (!this.abortReason) {
            await this.service.modal.error('세션 중단 사유를 선택해주세요.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '치료 세션 중단',
            message: '현재 세션을 중단하고 선택한 안전 사유를 기록합니다.',
            action: '세션 중단',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;
        this.pauseMedia();
        const payload = this.selectedSession?.status === 'scheduled'
            ? { reason_code: this.abortReason }
            : { ...this.playbackPositionPayload(), reason_code: this.abortReason };
        const success = await this.sendCommand('abort', payload);
        if (success) this.abortReason = '';
        await this.service.render();
    }

    public async submitSuds() {
        if (!this.selectedSession || this.commandBusy || this.checkpointBusy || !this.canRecordSuds()) return;
        const value = Number(this.sudsForm.value);
        if (!Number.isInteger(value) || value < 0 || value > 100 || !this.sudsForm.phase) {
            await this.service.modal.error('SUDs 값은 0부터 100 사이의 정수로 입력해주세요.');
            return;
        }
        await this.sendCommand('suds', {
            suds_value: value,
            suds_phase: this.sudsForm.phase
        });
    }

    public canRecordSuds() {
        const status = this.selectedSession?.status;
        const phase = this.sudsForm?.phase;
        if (phase === 'baseline') return ['scheduled', 'running', 'paused'].includes(status);
        if (phase === 'during') return ['running', 'paused'].includes(status);
        if (phase === 'post') return ['running', 'paused'].includes(status);
        return false;
    }

    public async submitSafetyEvent() {
        if (!['running', 'paused'].includes(this.selectedSession?.status) || this.commandBusy || this.checkpointBusy) return;
        const severity = Number(this.safetyForm.severity);
        if (!this.safetyForm.reason_code || !Number.isInteger(severity) || severity < 1 || severity > 5) {
            await this.service.modal.error('안전 사유와 1부터 5 사이의 심각도를 선택해주세요.');
            return;
        }
        this.pauseMedia();
        await this.sendCommand('safety_event', {
            reason_code: this.safetyForm.reason_code,
            severity: severity,
            ...this.playbackPositionPayload()
        });
    }

    private async sendCommand(command: string, payload: any = {}) {
        const id = this.sessionId(this.selectedSession);
        if (!id || this.commandBusy) return false;
        const fingerprint = this.commandFingerprint(command, payload);
        if (!this.commandKeys[fingerprint]) this.commandKeys[fingerprint] = this.newKey('session-' + command);
        this.commandBusy = command;
        this.detailError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('command', {
                session_id: id,
                command: command,
                idempotency_key: this.commandKeys[fingerprint],
                expected_version: this.selectedSession?.version,
                csrf_token: this.csrfToken(),
                ...payload
            });
            if (code !== 200) {
                this.detailError = data?.message || '세션 명령을 처리하지 못했습니다.';
                if (code === 409) {
                    await this.loadDetail(false, 0);
                    await this.drainTimeline();
                }
                return false;
            }
            delete this.commandKeys[fingerprint];
            if (data?.session) this.applySession(data.session, true);
            await this.loadDetail(
                command === 'start' || command === 'resume' ? false : true,
                command === 'start' || command === 'resume' ? 0 : this.eventCursor()
            );
            await this.drainTimeline();
            this.syncPolling();
            return true;
        } catch (error) {
            this.detailError = '세션 명령을 처리하지 못했습니다.';
            return false;
        } finally {
            this.commandBusy = '';
            await this.service.render();
        }
    }

    public async onMediaPlay(event: any) {
        if (!this.canPlay()) {
            this.suppressMediaEventsUntil = Date.now() + 1000;
            event?.target?.pause();
            await this.service.modal.warning('진행 중인 세션에서만 콘텐츠를 재생할 수 있습니다.', false, '확인');
            return;
        }
        await this.recordPlayback('start', event);
    }

    public async onMediaPause(event: any) {
        if (!this.selectedSession || event?.target?.ended || Date.now() < this.suppressMediaEventsUntil) return;
        await this.recordPlayback('pause', event);
    }

    public async onMediaSeeked(event: any) {
        if (Date.now() < this.suppressMediaEventsUntil) return;
        await this.recordPlayback('seek', event);
    }

    public async onMediaEnded(event: any) {
        await this.recordPlayback('complete', event);
    }

    public restorePlaybackPosition(event: any) {
        const element = event?.target;
        const asset = this.selectedPlanAsset();
        if (!asset || this.assetId(asset) !== String(this.selectedSession?.current_asset_revision_id || '')) return;
        const positionMs = Number(this.selectedSession?.playback_position_ms || 0);
        if (!element || !Number.isFinite(positionMs) || positionMs <= 0) return;
        const durationMs = Number(element.duration || 0) * 1000;
        if (durationMs > 0 && positionMs >= durationMs) return;
        this.suppressMediaEventsUntil = Date.now() + 1000;
        element.currentTime = positionMs / 1000;
    }

    private async recordPlayback(action: string, event: any) {
        const asset = this.selectedPlanAsset();
        if (!asset) return;
        const position = Math.max(0, Math.round(Number(event?.target?.currentTime || 0) * 1000));
        await this.recordCheckpoint(asset, action, position);
    }

    public async recordImagePlayback(action: string) {
        const asset = this.selectedPlanAsset();
        if (!asset || this.mediaType(asset) !== 'image') return;
        await this.recordCheckpoint(asset, action, 0);
    }

    private async recordCheckpoint(asset: any, action: string, position: number) {
        if (!['running', 'paused'].includes(this.selectedSession?.status) || this.checkpointBusy || this.commandBusy) return;
        const throttleKey = this.assetId(asset) + ':' + action;
        const now = Date.now();
        const throttleMs = action === 'seek' ? 5000 : 1500;
        if (now - Number(this.playbackSentAt[throttleKey] || 0) < throttleMs) return;
        this.playbackSentAt[throttleKey] = now;
        this.checkpointBusy = true;
        await this.service.render();
        const payload = {
            asset_revision_id: this.assetId(asset),
            position_ms: Math.max(0, Math.round(Number(position || 0))),
            playback_action: action
        };
        const fingerprint = this.commandFingerprint('checkpoint', payload);
        if (!this.commandKeys[fingerprint]) this.commandKeys[fingerprint] = this.newKey('session-checkpoint');
        try {
            const { code, data } = await wiz.call('command', {
                session_id: this.sessionId(this.selectedSession),
                command: 'checkpoint',
                idempotency_key: this.commandKeys[fingerprint],
                expected_version: this.selectedSession?.version,
                csrf_token: this.csrfToken(),
                ...payload
            });
            if (code === 200) {
                delete this.commandKeys[fingerprint];
                if (data?.session) this.applySession(data.session, true);
                // Idempotent replay returns the original command snapshot.
                // Re-read after its event cursor so concurrent later commands
                // cannot leave the player on a stale clinical state.
                await this.loadDetail(true, this.eventCursor());
                await this.drainTimeline();
                this.syncPolling();
            } else {
                this.detailError = data?.message || '재생 체크포인트를 기록하지 못했습니다.';
                if (code === 409) {
                    await this.loadDetail(false, 0);
                    await this.drainTimeline();
                }
            }
        } catch (error) {
            this.detailError = '재생 체크포인트를 기록하지 못했습니다.';
        } finally {
            this.checkpointBusy = false;
            await this.service.render();
        }
    }

    public async onMediaError(asset: any) {
        const key = String(asset?.plan_item_id || this.assetId(asset));
        const failedUrl = String(asset?.signed_url || '');
        if (!key || !failedUrl || this.mediaRefreshAttempts[key]?.retried === true) return;
        this.mediaRefreshAttempts[key] = { failedUrl, retried: true };
        await this.loadDetail(false, 0);
        await this.drainTimeline();
    }

    public markMediaLoaded(asset: any) {
        const key = String(asset?.plan_item_id || this.assetId(asset));
        if (key) delete this.mediaRefreshAttempts[key];
    }

    public eventTitle(event: any) {
        const type = String(event?.event_type || 'event');
        const action = String(event?.playback_action || '');
        const labels: any = {
            'session.created': '세션 계획 생성',
            'session.started': '세션 시작', session_started: '세션 시작', start: '세션 시작',
            'session.paused': '세션 일시정지', session_paused: '세션 일시정지', pause: '세션 일시정지',
            'session.resumed': '세션 재개', session_resumed: '세션 재개', resume: '세션 재개',
            'session.completed': '세션 완료', session_completed: '세션 완료', complete: '세션 완료',
            'session.aborted': '세션 중단', session_aborted: '세션 중단', abort: '세션 중단',
            'suds.recorded': 'SUDs 기록', suds_recorded: 'SUDs 기록', suds: 'SUDs 기록',
            'safety.recorded': '안전 이벤트', safety_event: '안전 이벤트', checkpoint: '재생 체크포인트',
            'playback.start': '재생 시작', 'playback.pause': '재생 일시정지',
            'playback.seek': '재생 위치 이동', 'playback.progress': '재생 진행',
            'playback.complete': '자산 재생 완료'
        };
        if (type === 'checkpoint' || type === 'playback') {
            const actions: any = { start: '재생 시작', pause: '재생 일시정지', seek: '재생 위치 이동', progress: '재생 진행', complete: '자산 재생 완료' };
            return actions[action] || labels[type];
        }
        return labels[type] || type.replace(/[_.]/g, ' ');
    }

    public eventDetail(event: any) {
        const values: string[] = [];
        if (event?.suds_value !== '' && event?.suds_value !== null && event?.suds_value !== undefined) {
            values.push('SUDs ' + event.suds_value + '/100');
            if (event?.suds_phase) values.push(this.sudsPhases.find((item: any) => item.value === event.suds_phase)?.label || event.suds_phase);
        }
        if (event?.reason_code) values.push(this.safetyReasons.find((item: any) => item.value === event.reason_code)?.label || event.reason_code);
        if (event?.severity) values.push('심각도 ' + event.severity + '/5');
        if (event?.position_ms !== '' && Number(event?.position_ms) > 0) values.push(this.duration(event.position_ms));
        if (event?.from_status && event?.to_status && event.from_status !== event.to_status) {
            values.push(this.statusLabel(event.from_status) + ' → ' + this.statusLabel(event.to_status));
        }
        return values.join(' · ') || '상태 변경 기록';
    }

    public formatDate(value: any) {
        if (!value) return '-';
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return String(value).slice(0, 19);
        return parsed.toLocaleString('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
    }

    private async selectInitialSession() {
        let candidates = this.viewMode === 'history'
            ? this.historySessions()
            : this.activeSessions();
        if (this.requestedSessionId) {
            const requested = this.sessions.find((item: any) =>
                this.sessionId(item) === this.requestedSessionId
            );
            if (requested) candidates = [
                requested,
                ...candidates.filter((item: any) => this.sessionId(item) !== this.requestedSessionId)
            ];
        }
        if (candidates.length > 0) {
            await this.selectSession(candidates[0]);
            return;
        }
        this.planningMode = false;
        await this.service.render();
    }

    public activeSessions() {
        return this.sessions.filter((item: any) =>
            ['scheduled', 'running', 'paused'].includes(String(item?.status || ''))
        );
    }

    public historySessions() {
        return this.sessions.filter((item: any) =>
            ['completed', 'aborted'].includes(String(item?.status || ''))
        );
    }

    public async selectSessionById(sessionId: string) {
        const item = this.sessions.find((row: any) => this.sessionId(row) === sessionId);
        if (item) await this.selectSession(item);
    }

    public async startNewPlan() {
        this.stopPolling();
        this.selectionGeneration += 1;
        this.selectedSession = null;
        this.selectedSessionKey = '';
        this.planningMode = true;
        this.detailError = '';
        this.plan = [];
        this.createKey = '';
        await this.service.render();
    }

    public async cancelPlanning() {
        this.planningMode = false;
        await this.selectInitialSession();
    }

    public workflowStep() {
        if (this.planningMode || !this.selectedSession || this.selectedSession?.status === 'scheduled') return 1;
        if (['running', 'paused'].includes(this.selectedSession?.status)) return 2;
        return 3;
    }

    public scenarioLabel(item: any = this.selectedSession) {
        const plan = Array.isArray(item?.plan) ? item.plan : [];
        const key = String(
            item?.scenario_type
            || plan[0]?.scenario_type
            || '승인 치료 시나리오'
        ).trim();
        const labels: any = {
            flight_phobia: '비행 공포',
            traffic_accident: '교통사고',
            place_era: '특정 장소·시대',
            other: '기타'
        };
        return labels[key] || key.replace(/_/g, ' ');
    }

    public mediaIconClass(asset: any) {
        const type = this.mediaType(asset);
        if (type === 'audio') return 'fa-solid fa-wave-square';
        if (type === 'video') return 'fa-solid fa-play';
        return 'fa-solid fa-image';
    }

    public isPlanCompleted(asset: any) {
        const id = this.assetId(asset);
        return (this.selectedSession?.timeline || []).some((event: any) =>
            String(event?.asset_revision_id || '') === id
            && String(event?.playback_action || '') === 'complete'
        );
    }

    public async moveSelectedPlan(direction: number) {
        const plan = Array.isArray(this.selectedSession?.plan) ? this.selectedSession.plan : [];
        const target = Math.max(0, Math.min(plan.length - 1, this.selectedPlanIndex + direction));
        if (target !== this.selectedPlanIndex) await this.selectPlanAsset(target);
    }

    public sudsEvents() {
        return (Array.isArray(this.selectedSession?.timeline) ? this.selectedSession.timeline : [])
            .filter((event: any) =>
                event?.suds_value !== '' && event?.suds_value !== null && event?.suds_value !== undefined
            )
            .sort((left: any, right: any) => Number(left?.sequence || 0) - Number(right?.sequence || 0));
    }

    public recentSuds() {
        return this.sudsEvents().slice(-5).reverse();
    }

    public lastSudsValue() {
        const events = this.sudsEvents();
        if (events.length > 0) return Number(events[events.length - 1]?.suds_value || 0);
        return Number(this.sudsForm.value || 0);
    }

    public async setSuds(value: number) {
        this.sudsForm.value = value;
        this.sudsForm.phase = this.selectedSession?.status === 'scheduled' ? 'baseline' : 'during';
        await this.service.render();
    }

    public safetyEvents() {
        return (Array.isArray(this.selectedSession?.timeline) ? this.selectedSession.timeline : [])
            .filter((event: any) =>
                String(event?.event_type || '').includes('safety')
                || String(event?.event_type || '') === 'safety_event'
            );
    }

    public safetyStateLabel() {
        return this.safetyEvents().length > 0 ? '안전 이벤트 기록됨' : '정상';
    }

    public sessionElapsedMs(item: any = this.selectedSession) {
        const accumulated = Number(item?.accumulated_duration_ms || 0);
        if (accumulated > 0 || !item?.started_at) return Math.max(0, accumulated);
        const start = new Date(item.started_at).getTime();
        const endValue = item?.completed_at || item?.aborted_at || '';
        const end = endValue ? new Date(endValue).getTime() : Date.now();
        if (!Number.isFinite(start) || !Number.isFinite(end)) return 0;
        return Math.max(0, end - start);
    }

    public formatElapsed(value: any) {
        const seconds = Math.max(0, Math.floor(Number(value || 0) / 1000));
        const minutes = Math.floor(seconds / 60);
        const remainder = String(seconds % 60).padStart(2, '0');
        return minutes + '분 ' + remainder + '초';
    }

    public timelineOffset(event: any) {
        const start = new Date(this.selectedSession?.started_at || this.selectedSession?.created || '').getTime();
        const current = new Date(event?.created || '').getTime();
        if (!Number.isFinite(start) || !Number.isFinite(current)) return '-';
        return this.duration(Math.max(0, current - start));
    }

    public sudsStats() {
        const values = this.sudsEvents().map((event: any) => Number(event.suds_value || 0));
        return {
            start: values.length > 0 ? values[0] : null,
            peak: values.length > 0 ? Math.max(...values) : null,
            end: values.length > 0 ? values[values.length - 1] : null
        };
    }

    public nextIntensity() {
        const plan = Array.isArray(this.selectedSession?.plan) ? this.selectedSession.plan : [];
        const current = Math.max(1, ...plan.map((item: any) => Number(item?.intensity || 1)));
        const stats = this.sudsStats();
        if (stats.end !== null && stats.start !== null && stats.end <= stats.start) {
            return Math.min(5, current + 1);
        }
        return Math.min(5, current);
    }

    public clinicalSummary() {
        const stats = this.sudsStats();
        if (this.selectedSession?.status === 'aborted') {
            return '안전 사유로 세션이 중단되었습니다. 타임라인의 안전 이벤트를 확인한 뒤 다음 계획을 조정하세요.';
        }
        if (stats.start === null) {
            return '기록된 SUDs가 없습니다. 재생 이벤트와 세션 상태를 기준으로 회차를 검토하세요.';
        }
        const trend = Number(stats.end) < Number(stats.peak)
            ? '최고점 이후 불편감이 감소했습니다.'
            : '종료 시점까지 불편감이 유지되었습니다.';
        return '시작 SUDs ' + stats.start + ', 최고 ' + stats.peak + ', 종료 ' + stats.end + '입니다. ' + trend;
    }

    public historyOutcome() {
        if (this.selectedSession?.status === 'aborted') return '중단';
        const stats = this.sudsStats();
        if (stats.end !== null && stats.start !== null && stats.end <= stats.start) return '달성';
        return '부분 달성';
    }

    public prepareNextSession() {
        const patientId = String(this.selectedSession?.patient_id || '');
        location.href = '/sessions' + (patientId ? '?patient_id=' + encodeURIComponent(patientId) : '');
    }

    private renderSudsChart() {
        if (this.viewMode !== 'history') return;
        const canvas = document.getElementById('session-suds-chart') as HTMLCanvasElement | null;
        if (!canvas) return;
        if (this.sudsChart) this.sudsChart.destroy();
        const events = this.sudsEvents();
        this.sudsChart = new Chart(canvas, {
            type: 'line',
            data: {
                labels: events.map((event: any) => this.timelineOffset(event)),
                datasets: [{
                    label: 'SUDs',
                    data: events.map((event: any) => Number(event.suds_value || 0)),
                    borderColor: '#0f72b7',
                    backgroundColor: 'rgba(15, 114, 183, 0.10)',
                    fill: true,
                    tension: 0.28,
                    pointRadius: 3,
                    pointHoverRadius: 5
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: { display: false },
                    tooltip: { displayColors: false }
                },
                scales: {
                    y: {
                        min: 0,
                        max: 100,
                        ticks: { stepSize: 25, color: '#64748b' },
                        grid: { color: 'rgba(148, 163, 184, 0.20)' }
                    },
                    x: {
                        ticks: { color: '#64748b', maxRotation: 0 },
                        grid: { display: false }
                    }
                }
            }
        });
    }

}

export default PageSessionsComponent;